<template>
  <kst-section :title="Info.Section.DebtReminder.Title">
    <kst-output field="DebtEmailLastSent" :data="details" :catalog="Catalog"/>
    <kst-output field="DebtDueReminderDays" :data="details" :catalog="Catalog"/>
    <kst-output field="DebtEmailSentTime" :data="details" :catalog="Catalog"/>

    <List class="mt-5"
      :emailList="details.DebtEmail"
    />
  </kst-section>
</template>

<script>
import Catalog from "../CpCatalog.js";
import Info from "../CpInfo.js";

import List from "./CpD_DebtReminder_List.vue";

export default {
  components: {
    List
  },
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog,
    Info: Info
  })
}
</script>